export default class Util {

  public static ID_TRUE = 'S';
  public static ID_FALSE = 'N';

  public static isIDTrue(id: string) {
    return id === Util.ID_TRUE;
  }

  public static getFieldsByZeedhiComponent(res: any): { [key: string]: any } {
    const fields = res.component.parent.parent.childrenInstances;

    const arrayFieldValues = fields.map((f: any) => ({ name: f.name, value: f.value }));
    const objectFieldValues: { [key: string]: any } = {};
    for (const item of arrayFieldValues) {
      objectFieldValues[item.name] = item.value;
    }

    return objectFieldValues;
  }

  public static formatHours(value: string | number): string {
    try {
      if (!value) return "00:00";
  
      // Se a entrada já estiver no formato "HH:MM", ajusta se necessário
      if (typeof value === 'string' && value.match(/^\d{2}:\d{2}$/)) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        let minutes = parseInt(minutesStr, 10);
  
        // Limita as horas para no máximo 24 e ajusta minutos para 00 se horas forem 24
        if (hours >= 24) {
          hours = 24;
          minutes = 0;
        }
  
        // Limita os minutos para no máximo 59
        if (minutes >= 60) {
          minutes = 59;
        }
  
        // Formata a saída como "HH:MM"
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      }
  
      let hours: string, minutes: string;
  
      if (typeof value === 'string' && value.includes(':')) {
        // Se a entrada for "HH:M", formata para "HH:MM"
        [hours, minutes] = value.split(':');
        minutes = minutes.padEnd(2, '0'); // Completa os minutos com zero à direita se necessário
      } else {
        // Assume que o valor é apenas horas (ex: "42" -> "42:00")
        hours = value.toString().padStart(2, '0');
        minutes = '00';
      }
  
      // Limita o valor de horas para no máximo 24
      let hoursInt = parseInt(hours, 10);
      if (hoursInt >= 24) {
        hoursInt = 24;
        minutes = '00';
      }
  
      // Limita os minutos para no máximo 59
      let minutesInt = parseInt(minutes, 10);
      if (minutesInt >= 60) {
        minutesInt = 59;
      }
  
      // Formata a saída como "HH:MM"
      return `${hoursInt.toString().padStart(2, '0')}:${minutesInt.toString().padStart(2, '0')}`;
    } catch (error) {
      return "00:00";
    }
  }

  /**
   * Limita o tamanho de uma string e adiciona "..." ao final se exceder o limite.
   * @param str - A string a ser truncada
   * @param maxLength - O tamanho máximo permitido
   * @returns A string truncada, com "..." no final
   */
  public static limitText(str: string, maxLength: number): string {
    if (!str) return '';
    if (str.length <= maxLength) return str;
    return str.slice(0, maxLength) + '...';
  }

  public static isNumeric(value: string): boolean {
    return !isNaN(Number(value));
  }
}